module.exports = __webpack_public_path__ + "static/media/TotalXp.13ef3189.svg";